module.exports = __webpack_public_path__ + "img/10-bn.7e60af9b.png";